export default "__VITE_PUBLIC_ASSET__f1b8d520__"